import { TextContentElement } from '@deltek/specification-client/core/Models/textContentElement'
import { Elements } from 'pages/ProjectsPage/WorkspacePage/components/Common/BestPracticeSyncTypes'
import { ContentItemViewNodesType } from '../../../types/contentItemViewNode.type'
import { DataNode } from '../../../types/types'
import { PRODUCT_TYPE_PROPERTY_NODE_TYPE } from '../constants'

const updateElementInArray = (
    elements: any[] | undefined,
    targetElementId: string,
    isBestPractice: boolean,
    isGlobalBestPractice: boolean
): any[] | undefined => {
    if (!elements) return elements

    return elements.map((element: any) => {
        if (element?.id === targetElementId) {
            return {
                ...element,
                isBestPractice,
                isGlobalBestPractice,
            }
        }
        if (element?.elements && Array.isArray(element.elements)) {
            return {
                ...element,
                elements: updateElementInArray(
                    element.elements,
                    targetElementId,
                    isBestPractice,
                    isGlobalBestPractice
                ),
            }
        }
        return element
    })
}

export const updateBestPracticesForContentItem = (
    contentItemId: string,
    elementId: string | undefined,
    contentNodes: Partial<ContentItemViewNodesType>[],
    isBestPractice: boolean,
    isGlobalBestPractice: boolean
) => {
    return contentNodes.map((item) => {
        if (item?.id === contentItemId) {
            if (!elementId) {
                return {
                    ...item,
                    isBestPractice,
                    isGlobalBestPractice,
                }
            }

            const updatedElements = updateElementInArray(
                item.elements,
                elementId,
                isBestPractice,
                isGlobalBestPractice
            )

            return {
                ...item,
                elements: updatedElements,
            }
        }

        if (item?.elements && elementId) {
            const hasNestedMatch = item.elements.some(
                (el: any) => el?.id === contentItemId
            )
            if (hasNestedMatch) {
                return {
                    ...item,
                    elements: updateElementInArray(
                        item.elements,
                        elementId,
                        isBestPractice,
                        isGlobalBestPractice
                    ),
                }
            }
        }

        return item
    })
}
export const buildContentElementsForSyncQuery = (
    elements: Partial<TextContentElement>[] | Partial<TextContentElement>[]
): Partial<TextContentElement>[] => {
    return elements.map((element: Partial<Elements>) => ({
        id: element.id,
        imperialUnits: element.imperialUnits,
        metricUnits: element.metricUnits,
        optionItemState: element.optionItemState,
        text: element.text,
        type: element.type,
        placeholderText: element.placeholderText,
        changeType: element.changeType,
        authoredUserId: element.authoredUserId,
        elements:
            element.elements && element.elements?.length !== 0
                ? buildContentElementsForSyncQuery(element.elements)
                : [],
    }))
}

/**
 * Finds a DataNode in a tree by content item ID (depth-first search).
 */
export const findNodeByContentItemId = (
    nodeId: string,
    nodes: DataNode[]
): DataNode | undefined => {
    for (const node of nodes) {
        if (node.contentItemView?.id === nodeId) {
            return node
        }
        if (node.children) {
            const found = findNodeByContentItemId(nodeId, node.children)
            if (found) return found
        }
    }
    return undefined
}

export const getContentItemOwnerId = (
    node: Partial<ContentItemViewNodesType>
): string | undefined => {
    return node?.propertyRefId && node?.propertyRefId !== ''
        ? node?.propertyRefId
        : node?.documentTemplateViewItemId ?? node?.dtvItemId
}
// Helper function to determine content item owner type
export const getContentItemOwnerType = (
    contentItemNode?: Partial<ContentItemViewNodesType>,
    parentNode?: Partial<ContentItemViewNodesType>
): string => {
    if (
        contentItemNode?.propertyRefId ||
        parentNode?.type === PRODUCT_TYPE_PROPERTY_NODE_TYPE
    ) {
        return 'ProductTypeProperty'
    }
    return contentItemNode?.contentItemOwnerType ?? 'Nugget'
}
